module.exports = __webpack_public_path__ + "img/insta-5.8abae4de.jpg";